module.exports = __webpack_public_path__ + "img/panel.137845a5.svg";